export default `:host {
  --broken-image-degree: -35deg;
}

:host([dir=rtl]) {
  --broken-image-degree: 35deg;
}

.ids-calendar-event:not([color]):not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-default);
}
.ids-calendar-event:not([color]):not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event:not([color]):focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}
.ids-calendar-event:not([color]) {
  background-color: var(--ids-calendar-event-color-background);
}

.ids-calendar-event:not(:has(.pending))[color=primary]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-primary);
}
.ids-calendar-event:not(:has(.pending))[color=primary]:not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event:not(:has(.pending))[color=primary]:focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}
.ids-calendar-event:not(:has(.pending))[color=primary] {
  background-color: var(--ids-calendar-event-color-background-accent-primary);
  color: var(--ids-calendar-event-color-forecolor-light);
}
.ids-calendar-event:not(:has(.pending))[color=blue]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-blue);
}
.ids-calendar-event:not(:has(.pending))[color=blue]:not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event:not(:has(.pending))[color=blue]:focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}
.ids-calendar-event:not(:has(.pending))[color=blue] {
  background-color: var(--ids-calendar-event-color-background-accent-blue);
}
.ids-calendar-event:not(:has(.pending))[color=orange]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-orange);
}
.ids-calendar-event:not(:has(.pending))[color=orange]:not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event:not(:has(.pending))[color=orange]:focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}
.ids-calendar-event:not(:has(.pending))[color=orange] {
  background-color: var(--ids-calendar-event-color-background-accent-orange);
}
.ids-calendar-event:not(:has(.pending))[color=neutral]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-neutral);
}
.ids-calendar-event:not(:has(.pending))[color=neutral]:not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event:not(:has(.pending))[color=neutral]:focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}
.ids-calendar-event:not(:has(.pending))[color=neutral] {
  background-color: var(--ids-calendar-event-color-background-accent-neutral);
}
.ids-calendar-event:not(:has(.pending))[color=purple]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-purple);
}
.ids-calendar-event:not(:has(.pending))[color=purple]:not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event:not(:has(.pending))[color=purple]:focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}
.ids-calendar-event:not(:has(.pending))[color=purple] {
  background-color: var(--ids-calendar-event-color-background-accent-purple);
}
.ids-calendar-event:not(:has(.pending))[color=green]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-green);
}
.ids-calendar-event:not(:has(.pending))[color=green]:not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event:not(:has(.pending))[color=green]:focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}
.ids-calendar-event:not(:has(.pending))[color=green] {
  background-color: var(--ids-calendar-event-color-background-accent-green);
}
.ids-calendar-event:not(:has(.pending))[color=red]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-red);
}
.ids-calendar-event:not(:has(.pending))[color=red]:not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event:not(:has(.pending))[color=red]:focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}
.ids-calendar-event:not(:has(.pending))[color=red] {
  background-color: var(--ids-calendar-event-color-background-accent-red);
}
.ids-calendar-event:not(:has(.pending))[color=teal]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-turqoise);
}
.ids-calendar-event:not(:has(.pending))[color=teal]:not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event:not(:has(.pending))[color=teal]:focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}
.ids-calendar-event:not(:has(.pending))[color=teal] {
  background-color: var(--ids-calendar-event-color-background-accent-turqoise);
}

.ids-calendar-event:has(.pending) {
  padding-inline-start: 4px;
}
.ids-calendar-event:has(.pending)[color=primary] {
  background-color: var(--ids-calendar-event-color-background-accent-primary);
  color: var(--ids-calendar-event-color-forecolor-light);
}
.ids-calendar-event:has(.pending)[color=primary]:not(.calendar-event-continue):not(.calendar-event-ends)::before {
  content: "";
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background-image: repeating-linear-gradient(var(--broken-image-degree), var(--ids-calendar-event-color-border-accent-primary) 0, var(--ids-calendar-event-color-border-accent-primary) 4px, transparent 4px, transparent 7px);
}
.ids-calendar-event:has(.pending)[color=blue] {
  background-color: var(--ids-calendar-event-color-background-accent-blue);
}
.ids-calendar-event:has(.pending)[color=blue]:not(.calendar-event-continue):not(.calendar-event-ends)::before {
  content: "";
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background-image: repeating-linear-gradient(var(--broken-image-degree), var(--ids-calendar-event-color-border-accent-blue) 0, var(--ids-calendar-event-color-border-accent-blue) 4px, transparent 4px, transparent 7px);
}
.ids-calendar-event:has(.pending)[color=orange] {
  background-color: var(--ids-calendar-event-color-background-accent-orange);
}
.ids-calendar-event:has(.pending)[color=orange]:not(.calendar-event-continue):not(.calendar-event-ends)::before {
  content: "";
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background-image: repeating-linear-gradient(var(--broken-image-degree), var(--ids-calendar-event-color-border-accent-orange) 0, var(--ids-calendar-event-color-border-accent-orange) 4px, transparent 4px, transparent 7px);
}
.ids-calendar-event:has(.pending)[color=neutral] {
  background-color: var(--ids-calendar-event-color-background-accent-neutral);
}
.ids-calendar-event:has(.pending)[color=neutral]:not(.calendar-event-continue):not(.calendar-event-ends)::before {
  content: "";
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background-image: repeating-linear-gradient(var(--broken-image-degree), var(--ids-calendar-event-color-border-accent-neutral) 0, var(--ids-calendar-event-color-border-accent-neutral) 4px, transparent 4px, transparent 7px);
}
.ids-calendar-event:has(.pending)[color=purple] {
  background-color: var(--ids-calendar-event-color-background-accent-purple);
}
.ids-calendar-event:has(.pending)[color=purple]:not(.calendar-event-continue):not(.calendar-event-ends)::before {
  content: "";
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background-image: repeating-linear-gradient(var(--broken-image-degree), var(--ids-calendar-event-color-border-accent-purple) 0, var(--ids-calendar-event-color-border-accent-purple) 4px, transparent 4px, transparent 7px);
}
.ids-calendar-event:has(.pending)[color=green] {
  background-color: var(--ids-calendar-event-color-background-accent-green);
}
.ids-calendar-event:has(.pending)[color=green]:not(.calendar-event-continue):not(.calendar-event-ends)::before {
  content: "";
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background-image: repeating-linear-gradient(var(--broken-image-degree), var(--ids-calendar-event-color-border-accent-green) 0, var(--ids-calendar-event-color-border-accent-green) 4px, transparent 4px, transparent 7px);
}
.ids-calendar-event:has(.pending)[color=red] {
  background-color: var(--ids-calendar-event-color-background-accent-red);
}
.ids-calendar-event:has(.pending)[color=red]:not(.calendar-event-continue):not(.calendar-event-ends)::before {
  content: "";
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background-image: repeating-linear-gradient(var(--broken-image-degree), var(--ids-calendar-event-color-border-accent-red) 0, var(--ids-calendar-event-color-border-accent-red) 4px, transparent 4px, transparent 7px);
}
.ids-calendar-event:has(.pending)[color=teal] {
  background-color: var(--ids-calendar-event-color-background-accent-turqoise);
}
.ids-calendar-event:has(.pending)[color=teal]:not(.calendar-event-continue):not(.calendar-event-ends)::before {
  content: "";
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background-image: repeating-linear-gradient(var(--broken-image-degree), var(--ids-calendar-event-color-border-accent-turqoise) 0, var(--ids-calendar-event-color-border-accent-turqoise) 4px, transparent 4px, transparent 7px);
}

.ids-calendar-event {
  position: absolute;
  box-sizing: border-box;
  width: 100%;
  z-index: var(--ids-z-index-10);
  background: var(--ids-calendar-event-color-background);
  border: 1px solid transparent;
  border-radius: var(--ids-border-radius-xs);
  color: var(--ids-calendar-event-color-text);
  overflow: hidden;
  text-decoration: none;
}
.ids-calendar-event .container {
  width: 100%;
}
.ids-calendar-event .header {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
}
.ids-calendar-event .header .icons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-inline-end: 4px;
  gap: 4px;
  flex-shrink: 0;
  margin-inline-start: auto;
}
.ids-calendar-event .header .icons ids-tooltip {
  position: absolute;
}
.ids-calendar-event.standalone {
  display: block;
  position: relative;
  height: unset;
}
.ids-calendar-event .gap {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  padding: var(--ids-space-3xs) 5px;
}
.ids-calendar-event .gap ids-text {
  display: block;
  width: 100%;
  height: 100%;
}
.ids-calendar-event .calendar-event-icon {
  vertical-align: bottom;
  position: relative;
  margin-inline-end: 1px;
  margin-inline-start: -1px;
}
.ids-calendar-event .calendar-event-icon[icon=success-alert] {
  color: var(--ids-calendar-event-color-icon-success);
}
.ids-calendar-event .calendar-event-icon[icon=alert-alert] {
  color: var(--ids-calendar-event-color-icon-alert);
}
.ids-calendar-event .calendar-event-icon[icon=clock] {
  color: var(--ids-calendar-event-color-icon-clock);
}
.ids-calendar-event .calendar-event-icon[icon=pending] {
  color: var(--ids-calendar-event-color-icon-pending);
}
.ids-calendar-event .calendar-event-title {
  line-height: 14px;
}
.ids-calendar-event .calendar-event-title::part(text) {
  text-transform: initial;
}
.ids-calendar-event.is-cutoff {
  border-radius: 3px 3px 0 0;
}
.ids-calendar-event.is-ellipsis .calendar-event-content {
  white-space: nowrap;
}
.ids-calendar-event.reduced-padding .calendar-event-content {
  padding: 0 5px;
}
.ids-calendar-event.reduced-padding .calendar-event-title {
  position: relative;
  top: -1.6px;
}
.ids-calendar-event .calendar-event-content {
  padding: 2px 5px;
}

.ids-calendar-event.all-day {
  top: 1px;
}
.ids-calendar-event.all-day .calendar-event-time,
.ids-calendar-event.all-day .calendar-event-comments {
  display: none;
}
.ids-calendar-event.all-day.calendar-event-start, .ids-calendar-event.all-day.calendar-event-continue, .ids-calendar-event.all-day.calendar-event-ends {
  border-radius: 0;
}
.ids-calendar-event.all-day.calendar-event-start {
  border-start-start-radius: 3px;
  border-end-start-radius: 3px;
}
.ids-calendar-event.all-day.calendar-event-continue {
  width: calc(100% + 2px);
  margin-inline-start: -1px;
}
.ids-calendar-event.all-day.calendar-event-ends {
  border-end-end-radius: 3px;
  border-start-end-radius: 3px;
}
.ids-calendar-event.all-day.calendar-event-continue ids-icon, .ids-calendar-event.all-day.calendar-event-ends ids-icon {
  visibility: hidden;
}
.ids-calendar-event.all-day.calendar-event-continue .calendar-event-title, .ids-calendar-event.all-day.calendar-event-ends .calendar-event-title {
  color: var(--ids-color-transparent);
}

.ids-calendar-event.is-month-view {
  position: absolute;
  display: block;
}
.ids-calendar-event.is-month-view:not(.all-day) {
  width: calc(100% - 10px);
  margin: 0 5px;
}
.ids-calendar-event.is-month-view.calendar-event-start, .ids-calendar-event.is-month-view.calendar-event-continue, .ids-calendar-event.is-month-view.calendar-event-ends {
  width: calc(100% - 5px);
}
.ids-calendar-event.is-month-view.calendar-event-start {
  margin-inline-start: 5px;
}
.ids-calendar-event.is-month-view.calendar-event-continue {
  width: 100%;
  margin-inline-start: 0;
}
.ids-calendar-event.is-month-view.calendar-event-ends {
  margin-inline-end: 5px;
}
.ids-calendar-event.is-month-view.hidden {
  display: none;
}
.ids-calendar-event.is-month-view .calendar-event-content {
  padding: 2px 4px;
  display: flex;
  align-items: center;
  height: 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
